import { IConfig } from './types';

const config: IConfig = {
  env: 'production',
  productName: 'Quiz Master',
  productUrl: 'https://www.quizmasterapp.in',
};

export default config;
